import React from "react";
import { CssBaseline } from "@mui/material";
import { Provider } from "react-redux";
import store from "./Store";
import { NotifierProvider } from "./Core/Notifier";
import { ThemeProviderWrapper } from "./Drawer/Menu/ThemeContext";
import GlobalLoader from "./Components/GlobalLoader/GlobalLoader";
import { ConfirmProvider } from "./Components/ConfirmDialog";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

interface WithAppProvidersProps {}

/**
 * Higher order function to wrap the application with redux store and other providers
 * @param Component - The component to wrap
 * @returns - A function that returns the wrapped component
 */
const withAppProviders =
  (Component: React.ComponentType<WithAppProvidersProps>) =>
  (props: WithAppProvidersProps) => {
    return (
      <Provider store={store}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <ThemeProviderWrapper>
            <NotifierProvider>
              <ConfirmProvider>
                <CssBaseline />
                <GlobalLoader />
                <Component {...props} />
              </ConfirmProvider>
            </NotifierProvider>
          </ThemeProviderWrapper>
        </LocalizationProvider>
      </Provider>
    );
  };

export default withAppProviders;
